var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "clickOutside",
      rawName: "v-clickOutside",
      value: _vm.hideFiligrane,
      expression: "hideFiligrane"
    }],
    staticClass: "w-64 2xl:w-88"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('info-bulle-hover', {
    attrs: {
      "name": 'filename' + _vm.id,
      "libelle": _vm.filename,
      "is-display-tooltip": _vm.isFilenameTooltipDisplay,
      "position": "bottom-3 left-0"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "text-left text-indigo-600 truncate w-full",
    on: {
      "mouseover": function ($event) {
        _vm.isFilenameTooltipDisplay = true;
      },
      "mouseleave": function ($event) {
        _vm.isFilenameTooltipDisplay = false;
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.filename) + "\n    ")])], 1), _vm._v(" "), _c('div', {
    class: 'relative h-64 2xl:h-88 rounded-md bg-gray-200',
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.showFiligrane.apply(null, arguments);
      },
      "mouseleave": function ($event) {
        return _vm.hideFiligrane();
      },
      "mouseenter": function ($event) {
        return _vm.showFiligrane();
      }
    }
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.isFiligrane ? _c('div', {
    staticClass: "top-0 left-0 bg-indigo-600 bg-opacity-85 absolute w-full h-full rounded-md p-6 z-20 flex justify-center items-center cursor-default"
  }, [_vm.editable && !_vm.isMoreDisplayed && !_vm.isDeleteDisplayed ? _c('div', {
    staticClass: "absolute right-4 top-4 p-2 cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.displayMore();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "more-vertical"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.isMoreDisplayed ? _c('div', {
    staticClass: "absolute right-6 top-6 flex space-x-3"
  }, [_vm.editable ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.editFile();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "edit"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.editable ? _c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.displayDelete();
      }
    }
  }, [_c('icon', {
    staticClass: "text-white",
    attrs: {
      "name": "trash-2"
    }
  })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), !_vm.isDeleteDisplayed ? _c('div', {
    staticClass: "border border-pink-600 rounded-full py-1.5 px-3.5 flex justify-center text-white text-sm w-max cursor-pointer transition-all duration-300 hover:bg-white hover:text-indigo-600",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.openFile();
      }
    }
  }, [_vm._v("\n          Voir l'image\n        ")]) : _vm._e(), _vm._v(" "), _vm.isDeleteDisplayed ? _c('div', {
    staticClass: "flex flex-col justify-center items-center space-y-5"
  }, [_c('div', {
    staticClass: "text-lg text-white"
  }, [_vm._v("\n            Supprimer l'image ?\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-row space-x-2"
  }, [_c('div', {
    staticClass: "border border-pink-600 rounded-md py-1.5 px-3.5 flex justify-center text-white text-sm font-light w-max cursor-pointer transition-all duration-300 hover:bg-white hover:text-pink-600 hover:border-transparent",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.deleteFile.apply(null, arguments);
      }
    }
  }, [_vm._v("\n              Oui, Supprimer\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "py-1.5 px-3.5 flex justify-center text-white text-sm font-light w-max cursor-pointer transition-all duration-300 hover:text-indigo-300",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.closeDelete.apply(null, arguments);
      }
    }
  }, [_vm._v("\n              Annuler\n            ")])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('img', {
    staticClass: "object-cover w-full h-full rounded-md",
    attrs: {
      "src": '/portfolio/' + _vm.infosPass.id_pass + '/' + _vm.file.filename,
      "alt": ""
    }
  })], 1), _vm._v(" "), _vm.file.description ? _c('div', {
    staticClass: "text-sm mt-3.5 flex flex-col space-y-1"
  }, [_c('p', {
    staticClass: "text-pink-600"
  }, [_vm._v("\n      Description\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "text-gray-600 italic"
  }, [_vm._v("\n      " + _vm._s(_vm.file.description) + "\n    ")])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }